var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.633 8.213h4.51L18.93 3v4.51c0 .388.315.703.703.703Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.967 27h14.062c1.163 0 2.11-.946 2.11-2.11V10.032h-4.922a2.112 2.112 0 0 1-2.11-2.11V3h-9.14c-1.164 0-2.11.946-2.11 2.11v19.78c0 1.164.946 2.11 2.11 2.11Zm4.218-12.703h7.032a.703.703 0 1 1 0 1.406h-7.032a.703.703 0 1 1 0-1.406Zm0 2.812h7.032a.703.703 0 1 1 0 1.407h-7.032a.703.703 0 1 1 0-1.407Zm0 2.813h7.032a.703.703 0 1 1 0 1.406h-7.032a.703.703 0 1 1 0-1.406Zm-2.812-5.625a.703.703 0 1 1 0 1.406.703.703 0 0 1 0-1.406Zm0 2.812a.703.703 0 1 1 0 1.407.703.703 0 0 1 0-1.407Zm0 2.813a.703.703 0 1 1 0 1.406.703.703 0 0 1 0-1.406Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.79586d14.svg";
export { ForwardRef as ReactComponent };